import React from "react";
import { isIE, isSafari } from 'react-device-detect';
import { Link } from 'react-router-dom';
import { injectIntl } from "react-intl";
import MediaQuery from 'react-responsive';
import * as paths from '@app/constants/paths';
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
// core components
import GridContainer from "@app/components/Grid/GridContainer";
import GridItem from "@app/components/Grid/GridItem";
import Button from "@app/components/CustomButtons/Button";

// styles
import bannerStyle from "@app/assets/jss/material-kit-pro-react/views/landingPageSections/bannerStyle";

import happyUserSMwebp from "@app/assets/img/stock/david-siglin-looking-happy-300w.webp";
import happyUserSMjp2 from "@app/assets/img/stock/david-siglin-looking-happy-300w.jp2";
import happyUserMDwebp from "@app/assets/img/stock/david-siglin-looking-happy-400w.webp";
import happyUserMDjp2 from "@app/assets/img/stock/david-siglin-looking-happy-400w.jp2";
import happyUserLGwebp from "@app/assets/img/stock/david-siglin-looking-happy-600w.webp";
import happyUserLGjp2 from "@app/assets/img/stock/david-siglin-looking-happy-600w.jp2";

const SignUpBanner = props => {
    const { classes } = props;

    const isWebpSupported = !(isIE || isSafari);
    const headline = props.intl.formatMessage({ id: "banner.sign.up.headline" });
    const description = props.intl.formatMessage({ id: "banner.sign.up.description" });
    const imgAlt = props.intl.formatMessage({ id: "banner.sign.up.image.alt" });

    return (
        <div
            className={classNames(
            classes.socialLine,
            classes.textCenter,
            classes.dark,
            classes.bigIcons
            )}
        >
        <div className={classes.container}>
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={6}>
                    <h2 className={classes.title}>
                        {headline}
                    </h2>
                    <p className={classes.description}>
                        {description}
                    </p>
                    <Button 
                        color="danger" 
                        size="lg"
                        to={paths.SIGN_UP_PROFESSIONAL} 
                        component={Link}
                        aria-label={props.intl.formatMessage({ id: "start.for.free" })}
                    >
                        <b>
                            {props.intl.formatMessage({ id: "start.for.free" })}
                        </b>
                    </Button>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <MediaQuery query="(max-device-width: 9999px)">
                        <MediaQuery query="(max-device-width: 420px)">
                            <a href={paths.SIGN_UP_PROFESSIONAL}>
                                <img className={classes.imageIcon} src={isWebpSupported ? happyUserSMwebp : happyUserSMjp2} alt={imgAlt} />
                            </a>
                        </MediaQuery>
                        <MediaQuery query="(min-device-width: 421px) and (max-device-width: 720px)">
                            <a href={paths.SIGN_UP_PROFESSIONAL}>
                                <img className={classes.imageIcon} src={isWebpSupported ? happyUserMDwebp : happyUserMDjp2}  alt={imgAlt} />
                            </a>
                        </MediaQuery>
                        <MediaQuery query="(min-device-width: 721px)">
                            <a href={paths.SIGN_UP_PROFESSIONAL}>
                                <img className={classes.imageIcon} src={isWebpSupported ? happyUserLGwebp : happyUserLGjp2}  alt={imgAlt} />
                            </a>
                        </MediaQuery>
                    </MediaQuery>
                </GridItem>
            </GridContainer>
        </div>
      </div>
    );
}

export default injectIntl(withStyles(bannerStyle)(SignUpBanner));